import RateYourExperienceDetails from '@comp/RateYourExperience/RateYourExperienceDetails';
import SubscriptionRatingStars from '@cont/Planner/PlannerCards/SubscriptionFeedbackCard/SubscriptionRatingStar';
import styled from '@emotion/styled';
import { Fonts, Spacings } from '@styles/index';
import boxShadowGenerator from '@utils/boxShadowGenerator';
import { useEffect, useState } from 'react';
import { getFeedbackOptions } from '@selectors/users';
import { useDispatch, useSelector } from 'react-redux';
import { fetchFeedbackOptions } from '@actions/auth';
import { submitSubscriptionFeedback } from '@api/fetchers/auth';
import { getIsSubmittingFeedback } from '@selectors/auth';
import { GTP_SUBSCRIPTION_FEEDBACK_CARD_SUBMITTED } from '@constants/segment';
import Image from '@base/Image';
import H4 from '@base/H4/H4';
import P1 from '@base/P1/P1';
import { GTP_SUBSCRIPTION } from '@cont/Planner/planner-constants';

const OuterWrapper = styled.div`
  padding-top: ${Spacings.SPACING_6B};
  height: ${({ $height }) => $height}px;
  grid-column: span 18;
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  background: linear-gradient(
      0deg,
      var(--color-i-orange-8),
      var(--color-i-orange-8)
    ),
    var(--color-base-1);
  background-repeat: no-repeat;
  background-position: bottom left;
  box-shadow: ${boxShadowGenerator()};
  border-radius: ${Spacings.SPACING_2B};
  padding-right: ${Spacings.SPACING_7B};
  height: 100%;
`;

const ContentWrapper = styled.div`
  width: 40%;
  margin-right: auto;
`;

const brownColor = 'var(--color-i-brown-4)';

const Title = styled(H4)`
  line-height: ${Fonts.PARA_LINE_HEIGHT};
`;

const Description = styled(P1)`
  line-height: ${Fonts.PARA_LINE_HEIGHT};
  margin-top: ${Spacings.SPACING_1B};
`;

const GTPSubscriptionFeedback = ({ goalUID, feedbackInfo }) => {
  const feedbackOptions = useSelector(getFeedbackOptions);
  const [ratingValue, setRatingValue] = useState(0);
  const isSubmittingFeedback = useSelector(getIsSubmittingFeedback);
  const [drawerState, setDrawerState] = useState(false);

  const { header, sub_text } = feedbackInfo.item_info;

  const handleCloseRatingDialog = (closeData) => {
    setRatingValue(0);
    const hasSubmittedFeedback = closeData?.hasSubmittedFeedback;
    if (hasSubmittedFeedback) {
      setDrawerState(false);
    } else {
      setDrawerState(false);
    }
  };

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchFeedbackOptions(goalUID, GTP_SUBSCRIPTION));
  }, [dispatch, goalUID]);

  const handleClick = (value) => () => {
    setRatingValue(value);
    setDrawerState(true);
  };
  return (
    <OuterWrapper>
      <RateYourExperienceDetails
        ratingValue={ratingValue}
        setRatingValue={setRatingValue}
        feedBackDetails={feedbackOptions}
        submitFeedback={submitSubscriptionFeedback}
        objectUID={goalUID}
        isSubmittingFeedback={isSubmittingFeedback}
        extraData={{ goalUID }}
        drawerState={drawerState}
        onClose={handleCloseRatingDialog}
        source={GTP_SUBSCRIPTION_FEEDBACK_CARD_SUBMITTED}
        goalUID={goalUID}
      />
      <Wrapper>
        <Image
          src="gtp/feedback-bg.svg"
          height={143}
          width={143}
          alt="feedback"
        />
        <ContentWrapper>
          <Title color={brownColor}>{header}</Title>
          <Description color={brownColor}>{sub_text}</Description>
        </ContentWrapper>
        <SubscriptionRatingStars value={ratingValue} setRating={handleClick} />
      </Wrapper>
    </OuterWrapper>
  );
};

export default GTPSubscriptionFeedback;
